export const defaultFlags = {
  showProgressDischargeForms: undefined,
  populatePractitionerDataFromOrgProfile: undefined,
  saveDraftForm: false,
  hideGisTransferFile: false
};
